import { render, staticRenderFns } from "./AllergenOverrideMatrix.vue?vue&type=template&id=064d62e5&scoped=true"
import script from "./AllergenOverrideMatrix.vue?vue&type=script&lang=ts"
export * from "./AllergenOverrideMatrix.vue?vue&type=script&lang=ts"
import style0 from "./AllergenOverrideMatrix.vue?vue&type=style&index=0&id=064d62e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d62e5",
  null
  
)

export default component.exports